export enum NormaliseDatesMethod {
    arithmetic = 'arithmetic',
    geometric = 'geometric',
}
